import { PureComponent, PropsWithChildren } from "react";

export default class SpellsFilterAdvancedFilterOption extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-spells-filter__adv-filter-option">
        {this.props.children}
      </div>
    );
  }
}
